<template>
  <div class="tabs">
    <h3 class="tabs__label">
      {{ label }}
    </h3>
    <div class="tabs__items">
      <label
        v-for="(item, itemIndex) in items"
        :key="itemIndex"
        class="tabs__item"
        :for="`radio-${itemIndex + 1}`"
      >
        <input
          :id="`radio-${itemIndex + 1}`"
          type="radio"
          name="name"
          :checked="itemIndex === checkedInit"
          class="tabs__item-input"
          @input="change(item)"
        >
        <div
          :for="`radio-${itemIndex + 1}`"
          class="tabs__item-icon"
        >
          <template v-if="item.image">
            <img
              :src="testUrl(item.image)"
              class="tabs__item-icon-img"
              alt=""
            >
          </template>
          <template v-else>
            <!--<span class="icon icon-engine" />-->
            <img
              src="/img/icons/engine-default.svg"
              class="tabs__item-icon-img"
              alt=""
            >
          </template>
        </div>
        <div
          class="tabs__item-label"
        >
          {{ item.label }}
          <span class="icon icon-ok" />
        </div>
      </label>
    </div>
    <Transition name="slide-from-top">
      <span
        v-if="error && errorMsg"
        class="input__error-msg"
        style="bottom: 0;"
      >
        {{ errorMsg }}
      </span>
    </Transition>
  </div>
</template>
<script>
  import crud from './crud'

  export default {
    name: 'ConsultationTabs',

    mixins: [crud],
    props: ['items', 'label', 'errorMsg', 'defaultEngine'],

    data () {
      return {
        error: null,
        checkedInit: 0
      }
    },

    watch: {
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      }
    },

    mounted () {
      this.change(this.items[0])

      if (this.defaultEngine && this.indexOfId(this.items, this.defaultEngine) > 0) {
        this.checkedInit = this.indexOfId(this.items, this.defaultEngine)
        this.change(
          this.items.find(item => item.value === this.defaultEngine)
        )
      }
    },

    methods: {
      indexOfId (array, id) {
        for (var i = 0; i < array.length; i++) {
          if (array[i].value === id) return i
        }
        return -1
      },

      change (item, e) {
        this.$emit('input', item.value, item)
        // if (item && item.value) {
        //   this.$emit('input', item.value, item)
        // } else {
        //   this.change(this.items[0])
        // }
      }
    }
  }
</script>
<style lang="scss">
  .tabs {
    position: relative;

    &__items {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -15px;

      @media (max-width: 1199px) and (min-width: 992px) {
        margin: 0 -7px;
      }
    }

    $parent: &;

    &__label {
      margin-top: 10px;
      margin-bottom: 20px;
      text-align: left;
    }

    &__item {
      display: flex;
      flex: 1 1 25%;
      flex-direction: column;
      max-width: 25%;
      padding: 0 15px;
      margin-bottom: 20px;
      white-space: nowrap;
      cursor: pointer;

      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        display: block;
      }

      @media (max-width: 1199px) and (min-width: 992px) {
        padding: 0 7px;
      }

      @include mobile () {
        flex: 1 1 50%;
        max-width: 50%;
      }

      @include hover () {
        #{$parent}__item-label {
          &::after {
            transform: translateX(100%);
          }
        }
      }

      &-icon {
        flex-grow: 1;
        margin-bottom: 12px;
        font-size: 35px;
        line-height: 3.5rem;
        text-align: center;

        &-img {
          width: 69px;
          max-height: 100%;
          object-fit: contain;
        }

        .icon {
          padding: 0;

          &::before {
            color: #7a7a7b;
          }
        }
      }

      &-label {
        position: relative;
        display: inline-block;
        width: 100%;
        padding-right: 20px;
        padding-bottom: 10px;
        overflow: hidden;
        font-size: 13px;
        line-height: 24px;
        color: $c-gray-dark;
        white-space: normal;

        &::before,
        &::after {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 3px;
          content: '';
        }

        &::before {
          right: 0;
          background: $c-gray-extra-light-3;
        }

        &::after {
          right: 100%;
          z-index: 0;
          background: $c-active;
          transition: transform 0.3s ease-out;
        }

        .icon {
          position: absolute;
          top: 1px;
          right: -1px;
          bottom: auto;
          width: 22px;
          height: 22px;
          padding: 0;
          font-size: 20px;
          font-weight: 700;
          line-height: 22px;
          text-align: center;
          background-color: transparent;
          border-radius: 50%;
          opacity: 0;
          transition: opacity 0.3s ease-in-out;

          &::before {
            color: $c-active;
          }
        }
      }
    }

    [type="radio"]:checked,
    [type="radio"]:not(:checked) {
      position: absolute;
      left: -9999px;
    }

    input[type=radio]:checked + .tabs__item-icon + .tabs__item-label .icon-ok {
      opacity: 1;
    }
  }

</style>
